var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGefionFacility4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.1562 38.75V10.7812C75.1562 4.83641 70.3198 0 64.375 0H61.7969C56.5614 0 52.1877 3.75172 51.2178 8.70734C47.512 9.66094 44.7656 13.0322 44.7656 17.0312V22.5H61.9531V17.0312C61.9531 13.2194 59.4586 9.97922 56.0158 8.85844C56.823 6.43797 59.1086 4.6875 61.7969 4.6875H64.375C67.7352 4.6875 70.4688 7.42109 70.4688 10.7812V38.75H49.4125C48.6297 33.2281 44.0453 28.9109 38.4016 28.5422C32.3503 19.2697 18.147 19.5911 12.5594 29.1656C8.3125 30.6234 5.27031 34.3359 4.64844 38.75H0V47.1203C0 58.8483 8.99203 68.5153 20.4448 69.5891L17.0555 78.2812H22.0869L25.4378 69.6875H54.5622L57.9131 78.2812H62.9445L59.5552 69.5891C71.008 68.5153 80 58.8483 80 47.1203V38.75H75.1562ZM57.2656 17.0312V17.8125H49.4531V17.0312C49.4531 14.8766 51.2047 13.125 53.3594 13.125C55.5141 13.125 57.2656 14.8766 57.2656 17.0312ZM45.9375 43.4375H60.7812V50.3125H45.9375V43.4375ZM14.7047 33.4156L15.7406 33.1594C19.2497 24.8072 30.6041 24.0381 35.0141 31.9937L35.7234 33.3L37.2062 33.2156C40.7378 32.9997 43.8698 35.4384 44.6453 38.75H9.41406C10.0281 36.1641 12.0328 34.0766 14.7047 33.4156ZM75.3125 47.1203C75.3125 56.9797 67.2922 65 57.4328 65H22.5672C12.7078 65 4.6875 56.9797 4.6875 47.1203V43.4375H41.25V55H65.4688V43.4375H75.3125V47.1203Z",
    fill: "#C49A36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGefionFacility4);
export default __webpack_public_path__ + "static/media/gefion-facility-4.42a2183b.svg";
export { ForwardRef as ReactComponent };